// 根级菜单
import HomeView from "@/views/home/HomeView.vue";
import AppLayout from "@/layouts/AppLayout.vue";
import NavigationLayout from "@/layouts/NavigationLayout.vue";

const generateAppRootRouter = ()=> {
  return {
    path: '/home',
    name: 'AppHome',
    component: HomeView,
    meta: {title: '首页', keepAlive: true},
    children: []
  }
}

const generateNavigationRootRouter = ()=> {
  return {
    path: '/home',
    name: 'NavigationHome',
    component: HomeView,
    meta: {title: '首页', keepAlive: true},
    children: []
  }
}

/**
 * 动态生成菜单
 */
export const generatorAppRouter = appList => {
  const rootRouter = generateAppRootRouter()
  const routerList = []
  appList.forEach(app => {
    const currentRouter= {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: `workplace/app/${app.id}`,
      // 路由名称，建议唯一
      name: app.code,
      // 该路由对应页面的 组件 :方案1
      // component: constantRouterComponents[item.component || item.key],
      // 该路由对应页面的 组件 :方案2 (动态加载)
      component: AppLayout,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: app.name,
        type: 'app',
        url: app.pcUrl,
        icon: app.icon
      }
    }
    routerList.push(currentRouter)
  })
  rootRouter.children = routerList
  return rootRouter
}

/**
 * 动态生成菜单
 */
export const generatorNavigationRouter = appList => {
  const rootRouter = generateNavigationRootRouter()
  const routerList = []
  appList.forEach(app => {
    const currentRouter= {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: `navigation/${app.id}`,
      // 路由名称，建议唯一
      name: app.code,
      // 该路由对应页面的 组件 :方案1
      // component: constantRouterComponents[item.component || item.key],
      // 该路由对应页面的 组件 :方案2 (动态加载)
      component: NavigationLayout,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: app.name,
        type: 'navigation',
        url: app.pcUrl,
        icon: app.icon
      }
    }
    routerList.push(currentRouter)
  })
  rootRouter.children = routerList
  return rootRouter
}
